export default "__VITE_ASSET__51Uizjq6__"